module.exports = __webpack_public_path__ + "img/img55.d1f7ac5a.svg";